type StorageType = 'session' | 'local';
type UseStorageReturnValue = {
  getItem: (key: string, type?: StorageType) => JSON | undefined;
  setItem: (key: string, value: object, type?: StorageType) => boolean;
  removeItem: (key: string, type?: StorageType) => void;
};

const useStorage = (): UseStorageReturnValue => {
  const storageType = (type?: StorageType): 'localStorage' | 'sessionStorage' =>
    `${type ?? 'session'}Storage`;

  const isBrowser: boolean = ((): boolean => typeof window !== 'undefined')();

  const getItem = (key: string, type?: StorageType): any | undefined => {
    if (isBrowser) {
      const item = window[storageType(type)][key];
      if (item) {
        try {
          const data = JSON.parse(item);
          return data;
        } catch (error) {
          console.error(error);
          return undefined;
        }
      }
    }

    return undefined;
  };

  const setItem = (key: string, value: object, type?: StorageType): boolean => {
    if (isBrowser) {
      const stringValue = JSON.stringify(value);
      window[storageType(type)].setItem(key, stringValue);
      return true;
    }

    return false;
  };

  const removeItem = (key: string, type?: StorageType): void => {
    if (isBrowser) {
      window[storageType(type)].removeItem(key);
    }
  };

  return {
    getItem,
    setItem,
    removeItem,
  };
};

export default useStorage;
